export default __webpack_public_path__ + "static/media/Prison-3D-Model-07.c9ff4560.jpg";